import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const OptionImage = ({ className, ...props }) => {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <img
      {...props}
      onError={() => setIsVisible(false)}
      onLoad={() => setIsVisible(true)}
      className={classNames(className, { 'd-none': !isVisible })}
    />
  );
};
OptionImage.propTypes = {
  className: PropTypes.string,
};

export default OptionImage;
